__turbopack_context__.v({
  "accordion-container": "_ydUaW_accordion-container",
  "accordion-item-container": "_ydUaW_accordion-item-container",
  "button": "_ydUaW_button",
  "content-container": "_ydUaW_content-container",
});
